export default () => ({
  show: false,
  beenUpdated: false,
  wasRaised: false,
  saved: false,
  includes: ['covenants'],
  covenants: [],
  price: {
    company_id: null,
    company_address_id: null,
    professional_id: null,
    kind: 'attendance',
    validity: null,
    value: null,
    covenants: []
  },
  kindOptions: [
    {
      id: 'attendance',
      label: 'Consultas'
    },
    {
      id: 'exam',
      label: 'Exames'
    },
    {
      id: 'others',
      label: 'Outros'
    }
  ],
  nextStepButtonPrices: [
    {
      icon: '',
      text: 'Nova Agenda Médica',
      name: 'professional.agenda.agendas.create',
      action: null
    },
    {
      icon: '',
      text: 'Honorários Médicos',
      name: 'professional.company.prices.create',
      action: true
    },
    {
      icon: '',
      text: 'Novo Funcionário',
      name: 'professional.company.employees.create',
      action: null
    }
  ],

  nextStepButtonPricesCompany: [
    {
      icon: '',
      text: 'Novo Profissional',
      name: 'professional.company.staffs.create',
      action: null
    },
    {
      icon: '',
      text: 'Novo Funcionário',
      name: 'professional.company.employees.create',
      action: null
    },
    {
      icon: '',
      text: 'Honorários Médicos',
      name: 'professional.company.prices.create',
      action: true
    }
  ],

  date: new Date(),
  config: {
    // minDate: new Date(),
    locale: 'pt-br',
    format: 'DD/MM/YYYY',
    useCurrent: false,
    widgetPositioning: {
      horizontal: 'left',
      vertical: 'bottom'
    }
  }
})



// WEBPACK FOOTER //
// ./src/app/professional/company/prices/form/resources/data.js